import { SupplierModelType } from '@teinor/erp/types/company/supplier'
import ModalCreateEdit from '../../../../../../baseComponents/ModalsLayouts/ModalCreateEdit'
import { ModalComponentProps } from '../../../../../../baseComponents/ModalsLayouts/types'
import { FormRender } from '../../../../../../forms/FormRenderer/types'
import { getDictionaryCountries } from '../../../../../../utils/reducers/getters'
import {  getDictionaryStates } from  '../../../../../../utils/globals/countries'
import useCountryState from '../../../../../../utils/hooks/useCountry'
import useTwinTranslation from '../../../../../../utils/hooks/useTwinTranslation'
import { useTypeIdNumber } from '../../../../../../utils/hooks/useTypeIdNumber'
import { getActiveLangs } from '../../../../../../utils/reducers/getters'
import { sortCountries } from '../../../../../../utils/globals/sortCountries'

interface ModalCreateCreditorProps extends ModalComponentProps { }

const ModalCreateCreditor: React.FC<ModalCreateCreditorProps> = ({ ...rest }) => {
    const { t } = useTwinTranslation()
    const { country, setCountry } = useCountryState()
    const { typesIdNumber } = useTypeIdNumber()

    const fields: FormRender<SupplierModelType> = [
        {
            cols: 2,
            elements: [
                {
                    name: 'name',
                    label: t('name', 'Nombre'),
                    component: 'InputWithLabelMargin',
                    type: 'text',
                    required: true
                },
                {
                    name: 'fiscal_name',
                    label: t('fiscalName', 'Nombre fiscal'),
                    component: 'InputWithLabelMargin',
                    type: 'text',
                },
                {
                    name: 'type_id_number',
                    label: t('typeIdNumber', 'Tipo de documento identificación'),
                    component: 'CustomSelect',
                    items: typesIdNumber,
                    value: 0,
                },
                {
                    name: 'id_number',
                    label: t('id_number', 'DNI'),
                    component: 'InputWithLabelMargin',
                    type: 'text',
                    required: true
                },
                {
                    name: 'code',
                    label: t('code', 'Código'),
                    component: 'InputWithLabelMarginIntegerStateFull',
                    type: 'text',
                },
            ]
        },
        {
            cols: 2,
            title: t('address', 'Dirección'),
            elements: [
                {
                    name: 'address',
                    label: t('address', 'Dirección'),
                    component: 'InputWithLabelMargin',
                    type: 'text',
                },
                {
                    name: 'additional_address',
                    label: t('number', 'Número'),
                    component: 'InputWithLabelMargin',
                    type: 'text'
                },
                {
                    name: 'postal_code',
                    label: t('postal_code', 'Código Postal'),
                    component: 'InputWithLabelMargin',
                    type: 'text',
                },
                {
                    name: 'city',
                    label: t('city', 'Ciudad'),
                    component: 'InputWithLabelMargin',
                    type: 'text',
                },
                {
                    name: 'country',
                    label: t('country', 'País'),
                    component: 'CustomSelectWithSearchBar',
                    items: getDictionaryCountries(),
                    sortFunction: sortCountries,
                    onChange: (value: string) => setCountry(value),
                    required: true
                },
                {
                    name: 'state',
                    label: t('state', 'Provincia'),
                    component: 'CustomSelectWithSearchBar',
                    sortItems: true,
                    items: getDictionaryStates(country),
                }
            ]
        },
        {
            cols: 2,
            title: t('contactInformation', 'Información de contacto'),
            elements: [
                {
                    name: 'email',
                    label: t('email', 'Email'),
                    component: 'InputWithLabelMargin',
                    type: 'email',
                },
                {
                    name: 'phone',
                    label: t('phone', 'Teléfono'),
                    component: 'InputWithLabelMargin',
                    type: 'text'
                },
                {
                    name: 'mobile',
                    label: t('mobile', 'Móvil'),
                    component: 'InputWithLabelMargin',
                    type: 'text'
                },
                {
                    name: 'LangId',
                    label: t('language', 'Idioma'),
                    component: 'CustomSelectWithSearchBar',
                    items: getActiveLangs(),
                },
                {
                    name: 'type',
                    component: 'InputHidden',
                    value: 1
                }
            ]
        }
    ]
    return (
        <ModalCreateEdit fields={fields} url={'/api/app/supplier/createSupplier'} translations={{
            title: t('createCreditor', 'Crear acreedor'),
            button: t('create', 'Crear')
        }} haveButtonPermissions={true} {...rest} />
    )
}

export default ModalCreateCreditor